export default {
    methods: {
        getDefaultFormulationStructure() {
            return {
                macronutrients: {
                    amino_acid: {
                        label: '',
                        quantity: '',
                        nitrogen: '',
                    },
                    glucose: {
                        label: '',
                        quantity_g: '',
                        quantity_kcal: '',
                    },
                    lipid: {
                        label: '',
                        quantity_g: '',
                        quantity_kcal: '',
                    },
                },
                electrolytes: [],
                chloride_acetate: {},
                micronutrients: {
                    trace_elements: [
                        {
                            name: '',
                            value: '',
                            unit: '',
                            type: '',
                        },
                    ],
                    vitamins: [{ name: '', value: '', unit: '' }],
                },
                additives: [],
            }
        },
        convertGlucose(unitFrom, UnitTo, value) {
            if (value) {
                if (unitFrom === 'g' && UnitTo === 'kcal') {
                    return value * 3.8;
                }
                if (unitFrom === 'kcal' && UnitTo === 'g') {
                    return value / 3.8;
                }
            }
            return '';
        },
        convertLipid(unitFrom, UnitTo, factor, value) {
            if (value) {
                if (unitFrom === 'g' && UnitTo === 'kcal') {
                    return value * factor;
                }
                if (unitFrom === 'kcal' && UnitTo === 'g') {
                    return value / factor;
                }
            }
            return '';
        },
        validNumber(num) {
            if (Number.isNaN(parseFloat(num))) {
                return false;
            }
            return true;
        },
        formatNumber(num, decimals) {
            return parseFloat(num).toFixed(decimals);
        },
    },
};
